import React from 'react';
import { ReportsView } from './components/ReportsView';

export const ReportsTab: React.FC = () => {
  return <ReportsView />;
};